module.exports = __webpack_public_path__ + "static/media/arrowBack.adf624e5.svg";